<template>
	<div class="proposed-table">
		<b-table-simple responsive borderless>
			<b-thead>
				<b-tr>
					<b-th>No.</b-th>
					<b-th class="w-100">Document Name</b-th>
					<b-th></b-th>
					<b-th></b-th>
				</b-tr>
			</b-thead>
			<b-tbody>
				<b-tr v-if="_gAuth.isAppSas() && !current_customer.cjp_id">
					<b-td class="text-center">1</b-td>
					<b-td>
						<div v-if="_gHlp.isEmpty(serviceEngagementApendixUrl)">
							<p class="mb-0">
								Unsign Service Engagement Form
								<small class="d-block" v-if="!_gHlp.isEmpty(app_form_esign_link)">{{app_form_esign_link}}</small>
								<small class="d-block text-secondary" v-if="!_gHlp.isEmpty(app_form_esign_link) && app_form_expired_date">Unsigned Service Engagement Form {{ app_form_expired_date }} </small>
								<u class="text-danger cursor-pointer" v-if="app_form_can_generate" href="javascript:void(0)" @click="generateAppFormLink()">Re-Generate</u>
							</p>
						</div>	
						<p v-else>Service Engagement Form</p>
					</b-td>
					<b-td>
						<!-- <a v-if="!_gHlp.isEmpty(app_form_esign_link)" class="cursor-pointer text-primary mx-1" :href="app_form_esign_down_link" download>Download</a> |  -->
						<a v-if="_gHlp.isEmpty(serviceEngagementApendixUrl) && !_gHlp.isEmpty(app_form_esign_link)" class="cursor-pointer text-primary mx-1" href="javascript:void(0)" @click="_gHlp.copyToClipboard(app_form_esign_link)">Copy Link</a> 
						<a v-if="_gHlp.isEmpty(serviceEngagementApendixUrl) && !_gHlp.isEmpty(app_form_esign_link)" class="cursor-pointer text-primary mx-1" href="javascript:void(0)" @click="sendToWhatsApp(app_form_esign_link)">Share Link</a>
						<a v-if="!_gHlp.isEmpty(serviceEngagementApendixUrl)" href="javascript:void(0)" class="cursor-pointer text-primary" @click="$refs.preview_modal.preview(serviceEngagementApendixUrl)">View</a>
					</b-td>
				</b-tr>
				<b-tr v-for="(item, index) in tableData" :key="index">
					<b-td class="text-center">{{ index + 2 }}</b-td>
					<b-td>{{ item.doc_name }}</b-td>
					<b-td>
						<a href="javascript:void(0)" class="cursor-pointer text-primary"
							@click="$refs.preview_modal.preview(item.url)">View</a>
					</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
		<PreviewModal ref="preview_modal"></PreviewModal>
	</div>
</template>
<script>
import { Select, Option } from 'element-ui'
import PreviewModal from '@/components/Modal/PreviewModal'
import { axios, services, getHeader, notifyFunctionMixin } from '@/assets/js/httpImports.js'
import { mapState, mapActions } from 'pinia'
import { useConfigStore } from '@/stores/configStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useEsignStore } from '@/stores/esignStore'

export default {
	props: ['proposal'],
	mixins: [notifyFunctionMixin],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		PreviewModal
	},
	data() {
		return {
			tableData: [
				// {
				//     doc_name: 'New House Loan Application'
				// },
				// {
				//     doc_name: 'Merchant Application'
				// },
				// {
				//     doc_name: 'New Credit Card Loan Application'
				// },
				// {
				//     doc_name: 'New Personal Loan Application'
				// },
				// {
				//     doc_name: 'Customer Signed Proposal'
				// },
			],
			serviceEngagementApendixUrl:null
		}
	},
	created() {
		this.initComponent()
	},
	computed: {
		...mapState(useConfigStore, ['app_code']),
		...mapState(useCustomerStore, ['current_customer','app_form_esign_down_link','app_form_esign_link','app_form_can_generate','app_form_expired_date']),
	},
	watch: {
		current_customer: {
			handler(newVal){
				if (newVal) {
					this.initComponent()
				}
			},
			immediate: true
		},
		proposal: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.initComponent()
				}
			},
			immediate: true,
		}
	},
	methods: {
		...mapActions(useEsignStore, ['getEsignDetail']),
		...mapActions(useCustomerStore, ['generateAppFormLink']),
		initComponent(){
			this.tableData = [];
			this.getCreditReport()
			if(!_gHlp.isEmpty(this.proposal)){
				this.getAppendix(this.proposal)
			}
			if(!_gHlp.isEmpty(this.current_customer)){
				this.setEngagementForm(this.current_customer)
			}
		},
		getCreditReport() {
			let queryParams = _gHlp.generateQueryParams({
				paginate:1,
				page:1,
				orderBy:{
					credit_report_id:'desc'
				},
				search:{
					credit_report_cust_id:this.proposal.customer_detail.customer_id,	
					credit_report_status:'completed',	
					credit_report_application_code:this.app_code,	
				}
			})

			const url = `${services.commitment}credit-reports?${queryParams}`
			axios.get(url, {headers: getHeader()})
			.then(res => {
					if (res.data.data.length > 0) {
						const report_name = _gHlp.getValue(res,'data.data.0.credit_report_platform') + ' Credit Report';
						const report_url = _gHlp.getValue(res,'data.data.0.credit_report_pdf_unsigned_url');
						console.log(report_name);
						if(_gHlp.isEmpty(this.tableData.find(itm => itm.doc_name == report_name)) && !_gHlp.isEmpty(report_url)){	
							this.tableData.push({
								doc_name: report_name,
								url: report_url
							})
						}
					}
			}).catch(e => {
					this.errorFunction(e)
			})
		},
		getAppendix(proposal){
			if(!_gHlp.isEmpty(proposal.appendixes)){
				for (const item of proposal.appendixes) {
					if(_gHlp.isEmpty(this.tableData.find(itm => itm.doc_name == item.papp_document_name))){
						this.tableData.push({
								doc_name: item.papp_document_name,
								url: item.url
						})
					}
				}
			}
		},
		setEngagementForm(customer){
			if(_gHlp.isEmpty(this.tableData.find(itm => itm.doc_name == 'Service Engagement Form'))){
				
				const esign_uuid = _gHlp.getValue(customer,'additional_detail.esign_application_form_json.esign_uuid')
				if(!_gHlp.isEmpty(esign_uuid)){
					this.getEsignDetail(esign_uuid).then(resp => {
						const  esign_attachment = _gHlp.getValue(resp, 'esign_attachment');
						if(!_gHlp.isEmpty(esign_attachment)){
							const appForm = esign_attachment.find(itm => itm.attachment_kind == 'APPLICATION_FORM');
							if(!_gHlp.isEmpty(appForm)){
								this.serviceEngagementApendixUrl = _gHlp.getValue(appForm,'attachment_unsigned_url')
							}
						}
					})
				}
			}
		}
	}
}
</script>